import Navigation from './Navigation';

const Store = {
  nav: new Navigation(),
}

export default Store
